module.exports = __webpack_public_path__ + "static/d26ed2f8.auth-bg.png";